module.exports = __webpack_public_path__ + "static/media/lock.be95a971.svg";